// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Overview_CardsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/overview/cards
 *
 * Returns the 6 hero KPIs for the new dashboard Visão Geral tab.
 *
 * Unit convention — ALL monetary fields are int cents (centavos).
 *
 * Field semantics (per docs/new-dashboard-plan.md §3):
 * - receita_liquida   = SUM(recebimento_valor_liquido) within session filter
 *                       (NB: anticipation fees / deductions are NOT yet
 *                       modeled as separate columns in `contas_recebimentos`,
 *                       so for Phase 1 they collapse into `valor_liquido` =
 *                       valor - valor_taxas. Surfaced as-is.)
 * - recebido_bruto    = SUM(recebimento_valor)
 * - a_receber         = SUM(compromisso_total * 100) − SUM(recebimento_valor)
 *                       for compromissos in filter range with status !=
 *                       Cancelado. CRITICAL unit conversion: compromisso_total
 *                       is stored as string-of-reais in the DB; recebimento_valor
 *                       is stored as int-cents. We multiply the former by 100
 *                       before subtraction.
 * - inadimplencia     = a_receber WHERE compromisso_data_hora_inicio <
 *                       today − 7 days AND status != Cancelado.
 * - lucro_bruto       = receita_liquida − despesas (despesas in reais → *100).
 *                       This is the "recebido" side: what came IN, net of payment
 *                       fees. Labelled "Lucro bruto (recebido)" on screen.
 * - lucro_bruto_faturado = faturamento − despesas, where faturamento is
 *                       SUM(compromisso_total*100) for compromissos in the filter
 *                       range with status != Cancelado — what was SOLD in the
 *                       period, paid or not (chamado 2026-0007). Labelled
 *                       "Lucro bruto (faturado)".
 *
 * DIVERGÊNCIA DELIBERADA, decidida em 2026-09-18: o "recebido" daqui é o
 * LÍQUIDO de taxas (receita_liquida), enquanto o "recebido" do resultado
 * financeiro (chamado 2026-0015, Recebimentos_model::totalRecebidoPorMes) é o
 * BRUTO. Alinhar os dois mudaria o lucro bruto para a rede inteira sem ninguém
 * pedir — exatamente o que o chamado 2026-0007 vetou ao mandar manter os dois
 * indicadores rotulados em vez de substituir um pelo outro. Quem for unificar
 * um dia: é uma linha, mas o número muda para todos, então precisa de decisão.
 *
 * Permission gating is uniform across all groups in this response — the
 * frontend hides specific tiles for Atendente per design decision #6.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Overview_CardsResponseDados {
receita_liquida: number
recebido_bruto: number
a_receber: number
inadimplencia: number
lucro_bruto: number
lucro_bruto_faturado: number
}

export type Overview_CardsResponse = ApiResponse<Overview_CardsResponseDados>;

registerResponseContract('Overview_CardsResponse', {
  receita_liquida:      { type: 'number',  required: true },
  recebido_bruto:       { type: 'number',  required: true },
  a_receber:            { type: 'number',  required: true },
  inadimplencia:        { type: 'number',  required: true },
  lucro_bruto:          { type: 'number',  required: true },
  lucro_bruto_faturado: { type: 'number',  required: true },
})
